import React from 'react';
import { Button, Segmented, Tabs } from 'antd';
import BookdealComponent from './BookdealComponent';
import { dealModel, registersuccess } from '../../../SweetAlert/SweetAlert';
import grecard from "../../../../assets/img/exam cards.jpeg"
import gre10 from "../../../../assets/img/profiles/bookdealimages/10 gre.jpg"
import gre20 from "../../../../assets/img/profiles/bookdealimages/20 gre.jpg"
import gre30 from "../../../../assets/img/profiles/bookdealimages/30 gre.jpg"






import duolingo10 from "../../../../assets/img/profiles/bookdealimages/10 duolingo.jpg"
import duolingo20 from "../../../../assets/img/profiles/bookdealimages/20 duolingo.jpg"
import duolingo30 from "../../../../assets/img/profiles/bookdealimages/30 duolingo.jpg"
import pet10 from "../../../../assets/img/profiles/bookdealimages/10 pte.jpg"
import pet20 from "../../../../assets/img/profiles/bookdealimages/20 pte.jpg"
import pet30 from "../../../../assets/img/profiles/bookdealimages/30 pte.jpg"
import ielts10 from "../../../../assets/img/profiles/bookdealimages/10 ielts.jpg"
import ielts20 from "../../../../assets/img/profiles/bookdealimages/20 ielts.jpg"
import ielts30 from "../../../../assets/img/profiles/bookdealimages/30 ielts.jpg"
import toefl10 from "../../../../assets/img/profiles/bookdealimages/10 toefl.jpg"
import toefl20 from "../../../../assets/img/profiles/bookdealimages/20 toefl.jpg"
import toefl30 from "../../../../assets/img/profiles/bookdealimages/30 toefl.jpg"
// import ielts10  from "../../../../assets/img/profiles/bookdealimages/10 ielts.jpg"
// import ielts20  from "../../../../assets/img/profiles/bookdealimages/20 ielts.jpg"
// import ielts30  from "../../../../assets/img/profiles/bookdealimages/30 ielts.jpg"

import BookdealComponen from './BookDealComponen';
import { useController, useForm } from 'react-hook-form';
import { createTheDeal } from '../../../HttpRequest/deals';


const onChange = (key) => {
  console.log(key);
};




// const data1=[
//     {
//         imageurl:"https://www.jeduka.com/storage/newsletter/1599896135_GRE.png",
//         title:"Register Today and get upto 20% Off on GRE Examination",
//         subtitle:"",
//         des:"",
//     }
// ]

const DiscountSlider = () => {
  const [alignValue, setAlignValue] = React.useState('center');
  const { control, handleSubmit,reset, setValue } = useForm();
  const items = [
    {
      key: '1',
      label: '10% Discount',
      children: (
        <>
          <div class="projcard-container">


            {/* <BookdealComponent  /> */}
            <div class="projcard-container">


              <BookdealComponen
                title="Register Today and get upto 10% Off on GRE Examination"
                imageurl={gre10}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-blue"
                cardType="gre10"
                setValue={setValue}
              />

              <BookdealComponen
                title="Register Today and get upto 10% Off on TOEFL Examination"
                imageurl={toefl10}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-red"
                cardType="tofel10"
                setValue={setValue}

              />



              <BookdealComponen
                title="Register Today and get upto 10% Off on PET Examination"
                imageurl={pet10}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-green"
                cardType="pte10"
                setValue={setValue}

              />

              <BookdealComponen
                title="Register Today and get upto 10% Off on  IELTS   Examination"
                imageurl={ielts10}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-red"
                cardType="ielts10"
                setValue={setValue}

              />


              <BookdealComponen
                title="Register Today and get upto 10% Off on duolingo Examination"
                imageurl={duolingo10}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-red"
                cardType="dulingo10"
                setValue={setValue}

              />
              {/*     
      <div class="projcard projcard-blue">
        <div class="projcard-innerbox">
          <img class="projcard-img" src={grecard} />
          <div class="projcard-textbox">
   
            <div class="projcard-title">Register Today and get upto 10% Off on GRE Examination</div>
            <div class="projcard-subtitle">Complete your registration and get ready to ace the exam</div>
            <div class="projcard-bar"></div>
            <div class="projcard-description">Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days.</div>
            <div class="projcard-tagbox">
              <span class="projcard-tag">10%</span>
              <span class="projcard-tag">30%</span>     
     
  
  </div>
  <button type="button" class="btn- btn btn-primary " data-bs-toggle="modal" data-bs-target="#exampleModal">
  Book Now
  </button>
            </div>
  
        </div>
      </div>
      
      <div class="projcard projcard-red">
        <div class="projcard-innerbox">
          <img class="projcard-img" src="https://banner2.cleanpng.com/20180622/egg/kisspng-test-of-english-as-a-foreign-language-toefl-sat-5b2d6fe16d3cc7.2114448715297044174475.jpg" />
          <div class="projcard-textbox">
              
        
            <div class="projcard-title">Register Today and get upto 10% Off on TOEFL Examination</div>
            <div class="projcard-bar"></div>
            <div class="projcard-subtitle">  Complete your registration and get ready to ace the exam  </div>
            <div class="projcard-description">Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days.</div>
            <div class="projcard-tagbox">
              <span class="projcard-tag">10%</span>
              <span class="projcard-tag">30%</span>     
            
   
            </div>
            <button type="button" class="btn- btn btn-primary " data-bs-toggle="modal" data-bs-target="#exampleModal">
  Book Now
  </button>
          </div>
        </div>
      </div>
      
      <div class="projcard projcard-green">
      <div class="projcard-innerbox">
          <img class="projcard-img" src="https://w7.pngwing.com/pngs/419/148/png-transparent-duolingo-logo-brand-logos-brands-in-colors-icon-thumbnail.png" />
          <div class="projcard-textbox">
            <div class="projcard-title">Register Today and get upto 10% Off on Duolingo Examination</div>
            <div class="projcard-subtitle">Complete your registration and get ready to ace the exam</div>
            <div class="projcard-bar"></div>
            <div class="projcard-description">Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days.</div>
            <div class="projcard-tagbox">
              <span class="projcard-tag">10%</span>
              <span class="projcard-tag">30%</span>     
            
          
            </div>
            <button type="button" class="btn- btn btn-primary " data-bs-toggle="modal" data-bs-target="#exampleModal">
  Book Now
  </button>
          </div>
        </div>
      </div> */}

              {/* <div class="projcard projcard-customcolor" >
        <div class="projcard-innerbox">
          <img class="projcard-img" src="https://picsum.photos/800/600?image=943" />
          <div class="projcard-textbox">
            <div class="projcard-title">Register Today and get upto 10% Off on PET Examination</div>
            <div class="projcard-subtitle">Complete your registration and get ready to ace the exam</div>
            <div class="projcard-bar"></div>
            <div class="projcard-description">Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days.</div>
            <div class="projcard-tagbox">
              <span class="projcard-tag">10%</span>
              <span class="projcard-tag">30%</span>     
            
            <Button type="primary" >Book Now</Button>
            </div>
          </div>
        </div>
      </div> */}

            </div>
          </div>

        </>
      ),
    },
    {
      key: '2',
      label: '20% Discount',
      children: (
        <>
          <div class="projcard-container">


            {/* <BookdealComponent  /> */}
            <div class="projcard-container">

              <BookdealComponen
                title="Register Today and get upto 20% Off on GRE Examination"
                imageurl={gre20}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-blue"
                cardType="gre20"
                setValue={setValue}

              />

              <BookdealComponen
                title="Register Today and get upto 20% Off on TOEFL Examination"
                imageurl={toefl20}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-red"
                cardType="tofel20"
                setValue={setValue}

              />



              <BookdealComponen
                title="Register Today and get upto 20% Off on PET Examination"
                imageurl={pet20}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-green"
                cardType="pet20"
                setValue={setValue}

              />

              <BookdealComponen
                title="Register Today and get upto 20% Off on 10 IELTS   Examination"
                imageurl={ielts20}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-red"
                cardType="ielts20"
                setValue={setValue}

              />


              <BookdealComponen
                title="Register Today and get upto 20% Off on duolingo Examination"
                imageurl={duolingo20}
                title1="Complete your registration and get ready to ace the exam"
                subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
                taglabel="20%"
                taglabel1="30%"
                projectclass="projcard-red"
                cardType="dulingo20"
                setValue={setValue}

              />

            </div>
          </div></>
      ),
    },
    {
      key: '3',
      label: '30% Discount',
      children: (<>
        <div>

          <div className='projcard-container'>
            <BookdealComponen
              title="Register Today and get upto 30% Off on GRE Examination"
              imageurl={gre30}
              title1="Complete your registration and get ready to ace the exam"
              subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
              taglabel="20%"
              taglabel1="30%"
              projectclass="projcard-blue"
              cardType="gre30"
              setValue={setValue}

            />

            <BookdealComponen
              title="Register Today and get upto 30% Off on TOEFL Examination"
              imageurl={toefl30}
              title1="Complete your registration and get ready to ace the exam"
              subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
              taglabel="20%"
              taglabel1="30%"
              projectclass="projcard-red"
              cardType="toefl30"
              setValue={setValue}

            />



            <BookdealComponen
              title="Register Today and get upto 20% Off on PET Examination"
              imageurl={pet20}
              title1="Complete your registration and get ready to ace the exam"
              subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
              taglabel="20%"
              taglabel1="30%"
              projectclass="projcard-green"
              cardType="pet30"
              setValue={setValue}

            />

            <BookdealComponen
              title="Register Today and get upto 30% Off on  IELTS   Examination"
              imageurl={ielts30}
              title1="Complete your registration and get ready to ace the exam"
              subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
              taglabel="20%"
              taglabel1="30%"
              projectclass="projcard-red"
              cardType="ielts30"
              setValue={setValue}

            />


            <BookdealComponen
              title="Register Today and get upto 30% Off on duolingo Examination"
              imageurl={duolingo30}
              title1="Complete your registration and get ready to ace the exam"
              subtitle="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
              taglabel="20%"
              taglabel1="30%"
              projectclass="projcard-red"
              cardType="dulingo30"
              setValue={setValue}

            />
          </div></div></>
      ),
    },
  ];

  const FullnameController = useController({
    name: 'fullName',
    control,
    defaultValue: '',
  });

  const PhoneNumberController = useController({
    name: 'phoneNumber',
    control,
    defaultValue: '',
  });
  const userId = localStorage.getItem("id");

  const onSubmit = async (data) => {
    const finalData = {
      ...data,
      userId: userId,
      status: "open",
    }
    console.log(finalData);
    const response = await createTheDeal(finalData);
    if(response.status === 200||response.status === 201){
      reset();
      registersuccess("Deal booked successfully");
    }
    console.log("response ==>", response);

  };
  return (
    <>


      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">Form  </h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

              {/* <div class="mb-3">
            <label for="recipient-name" class="col-form-label"></label>
            <input type="text" class="form-control" id="recipient-name" />
          </div> */}
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-3">
                  <label htmlFor="fullname" className="col-form-label">
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="fullname"
                    {...FullnameController.field}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="phoneNumber" className="col-form-label">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="phoneNumber"
                    {...PhoneNumberController.field}
                  />
                </div>

                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </form>
            </div>
            <div class="modal-footer">
              {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
              {/* <button type="button" class="btn btn-primary">Submit</button> */}
            </div>
          </div>
        </div>
      </div>
      <Tabs
        defaultActiveKey="1"
        items={items}
        onChange={onChange}
        indicator={{
          size: (origin) => origin - 20,
          align: alignValue,
        }}
      />
    </>
  );
};
export default DiscountSlider;